module.exports = __webpack_public_path__ + "static/media/videocall.dc36f586.svg";